import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

const STORAGE_KEY = "ardf_cart_v1";
const WISH_KEY = "ardf_wish_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    try {
      const c = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      const w = JSON.parse(localStorage.getItem(WISH_KEY) || "[]");
      setItems(Array.isArray(c) ? c : []);
      setWishlist(Array.isArray(w) ? w : []);
    } catch (e) {}
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    localStorage.setItem(WISH_KEY, JSON.stringify(wishlist));
  }, [wishlist]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((p) => p.id === product.id);
      if (existing) {
        return prev.map((p) =>
          p.id === product.id ? { ...p, qty: p.qty + qty } : p
        );
      }
      return [...prev, { ...product, qty }];
    });
  };

  const removeItem = (id) => setItems((prev) => prev.filter((p) => p.id !== id));

  const updateQty = (id, qty) =>
    setItems((prev) =>
      prev.map((p) => (p.id === id ? { ...p, qty: Math.max(1, qty) } : p))
    );

  const clear = () => setItems([]);

  const toggleWish = (product) => {
    setWishlist((prev) => {
      const exists = prev.find((p) => p.id === product.id);
      if (exists) return prev.filter((p) => p.id !== product.id);
      return [...prev, product];
    });
  };

  const inWishlist = (id) => !!wishlist.find((p) => p.id === id);

  const totals = useMemo(() => {
    const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
    const mrpTotal = items.reduce((s, i) => s + i.mrp * i.qty, 0);
    const savings = mrpTotal - subtotal;
    const shipping = subtotal >= 1499 || subtotal === 0 ? 0 : 79;
    const total = subtotal + shipping;
    const count = items.reduce((n, i) => n + i.qty, 0);
    return { subtotal, mrpTotal, savings, shipping, total, count };
  }, [items]);

  return (
    <CartContext.Provider
      value={{
        items,
        wishlist,
        addItem,
        removeItem,
        updateQty,
        clear,
        toggleWish,
        inWishlist,
        totals,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used inside CartProvider");
  return ctx;
};
